export const sendShareToActionKit = () => {
  const buttons = [
    ...document.querySelectorAll("[data-wm-send-share-to-action-kit]"),
  ];

  buttons.forEach((button) => {
    button.addEventListener(
      "click",
      (event) => {
        const shareUrl = event.currentTarget.dataset.wmSendShareToActionKit;
        fetch(shareUrl);
      },
      { once: true }
    );
  });
};
